import React, { useEffect, useState } from "react";
import { BASE_URL, BASE_IMAGE_URL } from "../../service/apiConfig";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import {
  Select,
  Typography,
  Space,
  Button,
  Table,
  Modal,
  Form,
  Input,
  notification,
  Upload,
  message,
  Card,
  DatePicker,
  Row
} from "antd";
import eventServiceApi from "../../service/eventService";
import eventCategoryApi from "../../service/eventCategoriesService";
import {
  EditorState,
  convertToRaw,
  ContentState,
  convertFromHTML,
} from "draft-js";
// import { useHistory } from "react-router-dom";
import { useParams } from "react-router-dom";
import "./management.css";
import draftToHtml from "draftjs-to-html";
// import htmlToDraft from "html-to-draftjs";
import translateApi from "../../service/translateService";
import isEqual from 'lodash/isEqual';

const { Option } = Select;
const { TextArea } = Input;
export default function ManagementPage() {
  const deepEqual = isEqual;
  const [eventCategoryId, setEventCategoryId] = useState(0);

  const [isShowUpdateEventCategory, setIsShowUpdateEventCategory] = useState(false);

  const [listEventCategory, setListEventCategory] = useState([]);

  const [fileListService, setFileListService] = useState([]);
  const [fileListServiceSubmit, setFileListServiceSubmit] = useState([]);

  const [loading, setLoading] = useState(false);
  const [invalidImage, setInvalidImage] = useState(false);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);

  const [form] = Form.useForm();
  const [formService] = Form.useForm();

  const [language, setLanguage] = useState("vi");
  const [dataChange, setDataChange] = useState(true);
  const [titleData, setTitleData] = useState("");
  const [desData, setDesData] = useState("");
  const [loadingTranslate, setLoadingTranslate] = useState(false);
  const [dataTranslate, setDataTranslate] = useState();
  const [lastData, setLastData] = useState({});

  useEffect(() => {
    getAllEventCategory();
  }, []);


  const onFormValueChange = () =>{
    setDataChange(true)
  }

  const getAllEventCategory = () => {
    eventCategoryApi.getAll().then((res) => {
      setListEventCategory(res.data);
    });
  };

  const deleteEvent = () => {
    eventCategoryApi.delete(eventCategoryId).then((res) => {
      notification.success({ message: `Delete event category success` });
      getAllEventCategory();
      setOpenDeleteDialog(false);
    });
  };

  const openModalEventCategory = (id) => {
    setIsShowUpdateEventCategory(true);
    setEventCategoryId(id);
    if (id) {
      eventCategoryApi.getById(id).then((res) => {
        formService.setFieldsValue({
          name: res.data.name,
          description: res.data.description,
        });
        setDesData(res.data.description);
        setTitleData(res.data.name);
      });
    }
  };

  const onCloseModalEventCategory = () => {
    setIsShowUpdateEventCategory(false);
    setFileListService([]);
    setFileListServiceSubmit([]);
    setLanguage("vi");
    setEventCategoryId(0);
    formService.setFieldsValue({
      name: "",
      description: "",
    });
  };

  const layout = {
    labelCol: { span: 5 },
    wrapperCol: { span: 20 },
  };

  const openDeleteService = (id) => {
    setEventCategoryId(id);
    setOpenDeleteDialog(true);
  };
  const columnsService = [
    {
      title: "Sự kiện",
      dataIndex: "name",
      key: "name",
      width:300
    },
    {
      title: "Mô Tả",
      dataIndex: "description",
      key: "description",
      width: 800
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Space size="middle">
          <Button
            type="primary"
            style={{
              borderRadius: 8,
            }}
            onClick={() => openModalEventCategory(_.id)}
          >
            Sửa
          </Button>
          <Button
            type="danger"
            style={{
              borderRadius: 8,
            }}
            onClick={() => openDeleteService(_.id)}
          >
            Xóa
          </Button>
        </Space>
      ),
    },
  ];

  const onFinishHandle = (values) => {
    if (eventCategoryId !== 0) {
      if (language === "vi") {
        eventCategoryApi.updateById(eventCategoryId, values).then((res) => {
          notification.success({ message: "Update event category success" });
          let newData = {}
        newData[language] = {}
        newData[language].name = form.getFieldValue("name")
        newData[language].description = form.getFieldValue("description")
        setLastData(newData)
        setDataChange(false)
        
          getAllEventCategory();
        //  onCloseModalEventCategory();
        });
      }else{
        var temp={}
        temp[language] =
        {
          name: values.name,
          description: values.description,
        }
        
        const data = { textTranslate: JSON.stringify(temp) };
        eventCategoryApi.updateById(eventCategoryId, data).then((res) => {
          notification.success({ message: "Update service category success" });
          let newData = {}
          newData[language] = {}
          newData[language].name = formService.getFieldValue("name")
          newData[language].description = formService.getFieldValue("description")
          setLastData(newData)
          setDataChange(false)
          getAllEventCategory();
        });
      }
    
    } else {
      console.log(values);
      eventCategoryApi.create(values).then((res) => {
        notification.success({ message: "Create event category success" });
        form.setFieldsValue({
          name: "",
          description: "",
        });
        getAllEventCategory();
        setIsShowUpdateEventCategory(false);
        onCloseModalEventCategory();
      });
    }
  };

  const onSelectLanguage = (value) =>  {
    onHandleTranslate(eventCategoryId, value)
    setDataChange(true)
    setLanguage(value);
  }

  const onChangeTitle = (value) => {
    setTitleData(value.target.value);
  };
  const onChangeDes = (value) => {
    setDesData(value.target.value);
  };

  const onHandleTranslate = (id, forceLang) => {
    setLoadingTranslate(true);
    const textData = {
      name: titleData,
      description: desData,
    };
    const data = {
      text: textData,
      language: forceLang ? forceLang:language,
      type: "eventCategory",
      id: id,
    };
    translateApi.translate(data).then((res) => {
      const textTranslate = res.data
      if (textTranslate.length > 0) {
        setLoadingTranslate(false);
        const newdata = []
        textTranslate.map((e) => {
          if (e.language == language) {
            formService.setFieldsValue({
              name: e.name,
              description: e.description,
            });
          }
        })
      } else {
        setLoadingTranslate(false);
        setDataTranslate(dataTranslate);
        let newFormData = {
          name: res.data.name,
          description: res.data.description,
        }
        setDataChange(false)
        if (!deepEqual(newFormData, lastData[data.language])){
          setDataChange(true)
        }
        formService.setFieldsValue({
          name: res.data.name,
          description: res.data.description,
        });
      }

    });
  };

  return (
    <>
      <Card
        title={
          <Typography style={{ textAlign: "center" }}>
            Quản lý loại sự kiện
          </Typography>
        }
        extra={
          <Button
            type="primary"
            style={{
              borderRadius: "8px",
            }}
            onClick={() => {
              setIsShowUpdateEventCategory(true);
            }}
          >
            Tạo Loại sự kiện
          </Button>
        }
      >
        <Table
          columns={columnsService}
          dataSource={listEventCategory}
          bordered
        />

        <Modal
          title={eventCategoryId !== 0 ? "Cập nhật loại sự kiện" : "Tạo loại sự kiện"}
          visible={isShowUpdateEventCategory}
          onCancel={() => {
            setEventCategoryId(0);
            onCloseModalEventCategory();
            setFileListServiceSubmit([]);
          }}
          footer={[
            <>
              <Button
                size="small"
                onClick={() => {
                  onCloseModalEventCategory();
                }}
              >
                {/* Close */}
                Đóng
              </Button>
              <Button
                size="small"
                className="btn btn-primary"
                type="primary"
                form="CU-tour"
                key="submit"
                htmlType="submit"
              >
                Save changes
              </Button>
            </>,
          ]}
        >
          <>
          {eventCategoryId!=0&&<Row justify="end" style={{marginBottom:"20px"}}>
                <Select
                  onChange={onSelectLanguage}
                  defaultValue="vi"
                  value={language}
                >
                  <Option value="vi">Tiếng Việt</Option>
                  <Option value="en">English</Option>
                  <Option value="fr">French</Option>
                  <Option value="zh-CN">Chinese</Option>
                  <Option value="ko">Korean</Option>
                  <Option value="de">German</Option>
                </Select>
                <Button
                  type="primary"
                  onClick={() => {
                    onHandleTranslate(eventCategoryId);
                  }}
                  loading={loadingTranslate}
                >
                  Dịch
                </Button>
              </Row>}
            {/* //// */}
            <Form
              {...layout}
              form={formService}
              name="CU-tour"
              onFinish={onFinishHandle}
              onValuesChange = {onFormValueChange}
            >
              <Form.Item
                name="name"
                label="Name"
                rules={[{ required: true }]}
                onChange={onChangeTitle}
              >
                <Input size="large"/>
              </Form.Item>

              <Form.Item name="description" label="Mô tả" onChange={onChangeDes}>
                <TextArea rows={4} />
              </Form.Item>
            </Form>
          </>
        </Modal>
      </Card>
      <Modal
        visible={openDeleteDialog}
        onOk={deleteEvent}
        onCancel={() => {
          setEventCategoryId(0);
          setOpenDeleteDialog(false);
        }}
        title={`Xóa sự kiện`}
      >
        Bạn có chắc muốn xóa loại sự kiện này?
      </Modal>
    </>
  );
}
